export default __webpack_public_path__ + "static/media/shortly.e896a994.png";